const isOdd = (value) => Math.abs(value % 2) === 1;

export default isOdd;
